<template>
  <div class="row">
    <div class="col-md-12">
      <p class="clearfix"></p>
      <challenge-campaign-form :route="route"></challenge-campaign-form>
    </div>
  </div>
</template>
<script>
import ChallengeCampaignForm from './ChallengeCampaignForm.vue'
export default {
  components: { ChallengeCampaignForm },
  props: {
    route: { type: Object, default: () => ({}) }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/ChallengeCampaigns/ChallengeCampaignEdit.vue